// extracted by mini-css-extract-plugin
export default {"customer-page-content":"CustomerPage_customer-page-content__qi08g","steps":"CustomerPage_steps__3-V7x","content":"CustomerPage_content__E36A-"};